import { render, staticRenderFns } from "./MediaModalEditor.vue?vue&type=template&id=1474c183&"
import script from "./MediaModalEditor.vue?vue&type=script&lang=js&"
export * from "./MediaModalEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MediaModalEditor.vue"
export default component.exports